import {
  HomebannerApiRequest,
  UpdateHomebannerRequest,
} from '@/data/payload/api/HomebannerRequest'
import {
  PostHomebannerInterface,
  DeleteHomebannerInterface,
  UpdateHomebannerInterface,
} from '@/data/payload/contracts/HomebannerRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { HomebannerDataMapper } from '@/data/persistences/mappers/HomebannerDataMapper'
import { HomebannerRepositoryInterface } from '@/data/persistences/repositories/contracts/HomebannerRepositoryInterface'
import { Homebanner } from '@/domain/entities/Homebanner'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class HomebannerApiRepository implements HomebannerRepositoryInterface {
  private service: ApiService
  private mapper: HomebannerDataMapper

  constructor(service: ApiService, mapper: HomebannerDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async delete(payload: DeleteHomebannerInterface): Promise<Homebanner> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.HOME_BANNER_DELETE,
      undefined,
      payload as HomebannerApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async post(payload: PostHomebannerInterface): Promise<Homebanner> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.HOME_BANNER,
      undefined,
      payload as HomebannerApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdateHomebannerInterface,
    id: number
  ): Promise<Homebanner> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.HOME_BANNER}/${id}`,
      undefined,
      payload as UpdateHomebannerRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async getAll(params: Object): Promise<Homebanner> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.HOME_BANNER,
      params
    )
    return this.mapper.convertHomebannerFromApi(resp)
  }
}
